import { put, select, takeEvery } from "redux-saga/effects";
import { OfferStates, setOfferStates, setTime } from "..";
import {
  calculateClosingTimes,
  getCurrentDiscountStatus
} from "../calculateClosingTimes/calculator";
import { selectRestaurantsOfferState } from "../offerSelectors";
import { restaurantsSelector } from "../selectors";

const offerStateEqual = (a: OfferStates, b: OfferStates) => {
  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false;
  }
  for (const r of Object.keys(a)) {
    if (a[r] !== b[r]) {
      return false;
    }
  }
  return true;
};

function* calculateOfferState({ payload }: ReturnType<typeof setTime>) {
  const time = new Date(payload);
  const restaurants: RestaurantFromAPI[] | null = yield select(
    restaurantsSelector
  );
  if (restaurants) {
    const restaurantsWithClosingTimes = calculateClosingTimes(
      restaurants,
      time
    );
    const offerState = restaurantsWithClosingTimes.reduce(
      (acc: OfferStates, val) => {
        acc[val._id] = getCurrentDiscountStatus(val.closingTimes, time).status;
        return acc;
      },
      {}
    );
    const oldOfferState = yield select(selectRestaurantsOfferState);

    if (!offerStateEqual(oldOfferState, offerState)) {
      yield put(setOfferStates(offerState));
    }
  }
}

export default function*() {
  yield takeEvery(setTime, calculateOfferState);
}
